import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';

import {toTitleCase} from 'js/common/string_helper';
import * as ObjectHelper from 'js/common/object_helper';

const ContentRequirementsDetails = ({
    contentUse,
    platformHandle,
    campaignDisplayType,
    enums,
    gqlData,
    isLegacyCampaign,
}) => {

    const contentUseVal = ObjectHelper.propOr('N/A', contentUse, enums.ContentUse);

    const getContentUseValue = () => {
        if (isLegacyCampaign) {
            return contentUseVal;
        }
        if (!isLegacyCampaign && gqlData.contentUse) {
            return gqlData.contentUse;
        }
        return null;
    };

    const contentTypeVal = campaignDisplayType
            ? toTitleCase(R.last(R.split('_', campaignDisplayType)))
            : 'N/A';

    const contentType = isLegacyCampaign ? contentTypeVal : gqlData.contentType;

    const getContentFormat = () => {
        if (!isLegacyCampaign && gqlData.contentFormat) {
            return gqlData.contentFormat;
        }
        return null;
    };

    const getContentSize = () => {
        if (!isLegacyCampaign && gqlData.contentSize) {
            return gqlData.contentSize
        }
        return null;
    };

    const getContentDistribution = () => {
        if (!isLegacyCampaign) {
            const hasDistribution = gqlData && gqlData.socialChannel ? 'Yes' : 'No';
            return hasDistribution;
        }
        return null;
    };

    return (
    <div className="detail-section">
        <div className="detail-section-title">
            <h5>Content Requirements</h5>
        </div>

        <div className="detail-section-grid">
            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">What Are We Making Content For?</p>
                <div className="item-value">{getContentUseValue()}</div>
            </div>

            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">What Platform?</p>
                <div className="item-value">{platformHandle || 'N/A'}</div>
            </div>

            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">Creators Should Post On Social</p>
                <div className="item-value">{getContentDistribution()}</div>
            </div>

            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">What Type Of Content Are We Making?</p>
                <div className="item-value">{contentType}</div>
            </div>

            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">How do You Want To Place The Content?</p>
                <div className="item-value">{getContentFormat()}</div>
            </div>

            <div className="detail-section-grid-item">
                <p className="content-section-title -no-margin">Content Size</p>
                <div className="item-value">{getContentSize()}</div>
            </div>
        </div>
    </div>
    );
};


ContentRequirementsDetails.propTypes = {
    contentUse: PropTypes.string,
    platformHandle: PropTypes.string
};

export default ContentRequirementsDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/content_requirements_details.js